<template>
  <!-- 柱状图图表 -->
  <div id="columecharts" ref="columecharts">
    
  </div>
</template>

<script>
export default {
  data(){
    return {
      yDataName: []
    }
  },
  props: ['echartdata'],
  mounted(){
    console.log(this.echartdata.columdata)
    for (let i = 0; i < this.echartdata.columdata.yData.length; i++) {
      this.echartdata.columdata.yData[i].type = 'bar'
      this.yDataName.push(this.echartdata.columdata.yData[i].name)      
    }
    this.drawChart()
  },
  methods:{
    /*
    option = {
    title: {
        text: '某地区蒸发量和降水量',
        subtext: '纯属虚构'
    },
    tooltip: {
        trigger: 'axis'
    },
    legend: {
        data: ['蒸发量', '降水量']
    },
    toolbox: {
        show: true,
        feature: {
            dataView: {show: true, readOnly: false},
            magicType: {show: true, type: ['line', 'bar']},
            restore: {show: true},
            saveAsImage: {show: true}
        }
    },
    calculable: true,
    xAxis: [
        {
            type: 'category',
            data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
        }
    ],
    yAxis: [
        {
            type: 'value'
        }
    ],
    series: [
        {
            name: '蒸发量',
            type: 'bar',
            data: [2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3]
        },
        {
            name: '降水量',
            type: 'bar',
            data: [2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3]
        }
    ]
}; */
      drawChart(){
        let coluchart = this.$echarts.init(this.$refs.columecharts);
        let option = {
          grid: {
              top: '12%',
              left: '5%',
              right: '8%',
              bottom: '5%',
              containLabel: true
          },
          dataZoom: [{
            type: 'slider',
            show: true,
            xAxisIndex: [0],
            left: '9%',
            bottom: -5,
            start: 1,
            end: 50 //初始化滚动条
          }],
          legend: {
            data: this.yDataName
          },
          xAxis: [
            {
                type: 'category',
                data: this.echartdata.columdata.xData
            }
          ],
          yAxis: [
            {
                type: 'value'
            }
          ],
          series: this.echartdata.columdata.yData
        };
        // 绘制图表
        coluchart.setOption(option);
      }
  }

}
</script>

<style  lang="stylus" scoped>
#columecharts{
    height:500px;
    background-image:url('../assets/images/data/waterbg.png')
}
</style>